import { ActionTypes } from './action-types.enum';

const initialState = {
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_ERROR:
      return {
        ...state,
        show: action.payload.show,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
};
